import { trpc } from '$src/lib/trpc'
import type { MessageDescriptor } from '@lingui/core'
import { msg } from '@lingui/core/macro'
import { createChatHooks } from '@markku/components'
import { sum } from '@markku/utils'
import {
  IconBook,
  IconCalendar,
  IconHome,
  IconMessage,
  IconUser,
} from '@tabler/icons-react'

export type NavigationTab =
  | 'home'
  | 'maintenance'
  | 'visits'
  | 'messages'
  | 'profile'

export interface NavigationItem {
  id: NavigationTab
  icon: React.ReactNode
  label: MessageDescriptor
  route: string
  badge?: number
}

export function useUnreadMessageCount() {
  const chatHooks = createChatHooks(trpc)
  const { data: rooms } = chatHooks.useGetRooms()
  return sum(rooms?.map((r) => r.unreadCount) || [])
}

export function getNavigationItems(
  iconSize: number,
  unreadCount: number,
): NavigationItem[] {
  return [
    {
      id: 'home',
      icon: <IconHome size={iconSize} />,
      label: msg`Home`,
      route: '/home',
    },
    {
      id: 'maintenance',
      icon: <IconBook size={iconSize} />,
      label: msg`Maintenance`,
      route: '/maintenance',
    },
    {
      id: 'visits',
      icon: <IconCalendar size={iconSize} />,
      label: msg`Visits`,
      route: '/visits',
    },
    {
      id: 'messages',
      icon: <IconMessage size={iconSize} />,
      label: msg`Messages`,
      route: '/messages',
      badge: unreadCount,
    },
    {
      id: 'profile',
      icon: <IconUser size={iconSize} />,
      label: msg`Profile`,
      route: '/profile',
    },
  ]
}
